<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="w-full h-full fixed top-0 left-0 -z-10 bg-[#e5e7eb]"></div>
    <Header />

    <div class="p-5 lg:p-10">
      <div class="w-full h-full py-5 flex flex-col gap-5">
        <!-- <img src="@/assets/CIT_Blue_square.png" alt="" class="w-60 mx-auto object-contain" /> -->
        <router-link
          :to="{ name: 'StudentHome' }"
          class="brand w-nav-brand w--current flex items-center"
        >
          <img
            :src="logo_image"
            alt="Logo"
            class="w-60 mx-auto object-contain"
          />
        </router-link>

        <form
          @submit.prevent="submitForm"
          class="p-4 w-[95%] lg:w-[400px] mx-auto bg-white rounded-3xl shadow-lg flex flex-col gap-5"
        >
          <h1 class="font-medium text-3xl text-center py-4 text-gray-800">
            Daily Feedback
          </h1>

          <div class="flex items-center pb-2 gap-2">
            <div class="flex gap-2 items-center">
              <h2 class="text-sm font-semibold">
                Daily Feedback for {{ current_day }} order of timetable Date/day
                : {{ current_date }} / {{ current_day }}
              </h2>
            </div>
          </div>

          <div class="flex flex-col gap-2 border-2 rounded-lg p-3">
            <h2 class="text-sm font-semibold">Notes:</h2>
            <table class="min-w-full">
              <tbody>
                <tr v-for="(fb, index) in feedbackList" :key="index">
                  <td class="text-sm font-semibold capitalize py-2">
                    {{ index + 1 }}
                  </td>
                  <td>:</td>
                  <td class="text-sm px-2">{{ fb.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="w-full py-4">
            <table class="w-full border-collapse border border-gray-200">
              <thead>
                <tr>
                  <th
                    class="border border-gray-200 text-black px-2 text-center font-semibold"
                    rowspan="2"
                  >
                    Subject
                  </th>
                  <th
                    class="border border-gray-200 text-black px-2 text-center font-semibold"
                    colspan="4"
                  >
                    Feedback
                  </th>
                </tr>
                <tr>
                  <th
                    class="border border-gray-200 text-black px-2 text-center font-semibold"
                  >
                    1
                  </th>
                  <th
                    class="border border-gray-200 text-black px-2 text-center font-semibold"
                  >
                    2
                  </th>
                  <th
                    class="border border-gray-200 text-black px-2 text-center font-semibold"
                  >
                    3
                  </th>
                  <th
                    class="border border-gray-200 text-black px-2 text-center font-semibold"
                  >
                    4
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="cls in subjectList" :key="cls.sub_code">
                  <td> 
                    <input
                      type="hidden"
                      :name="`subject-code-${cls.subject_pk}`"
                      :value="cls.subject_pk"
                    />
                  </td>
                  <td class="border border-gray-200 px-2">
                    {{ cls.sub_name }} ({{ cls.sub_code }})
                  </td>
                  <td
                    class="border border-gray-200 px-2"
                    v-for="feedback in feedbackList"
                    :key="feedback.id"
                  >
                    <input
                      type="radio"
                      class="w-4 h-4 rounded-full"
                      :name="`feedback-reason-${cls.sub_name}-${cls.session}`"
                      :value="feedback.id"
                      required
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div id="div_id_password" class="relative text-left">
              <label for="reason" class="font-medium block mt-4 text-gray-700"
                >Remarks</label
              >
              <textarea
                v-model="remarks"
                placeholder="Enter your remarks here!"
                name="student_remarks"
                cols="30"
                rows="5"
                class="w-full px-3 py-2 bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-800 leading-8 transition-colors duration-200 ease-in-out"
              ></textarea>
            </div>
          </div>

          <button
            v-if="hidebutton == false"
            class="w-full bg-indigo-700 hover:bg-indigo-900 text-white font-medium py-3 px-4 mt-2 rounded focus:outline-none focus:shadow-outline"
            type="submit"
          >
            Save
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
export default {
  data() {
    return {
      remarks: "",
      feedbackList: null,
      subjectList: null,
      current_date: "",
      current_day: "",
      logo_image: require(`${process.env.VUE_APP_COMS_LOGO}`),
      messages: {
        text: "",
        type: "null",
      },
      hidebutton: false,
      feedback_check: null,
    };
  },
  components: {
    Header,
    FlashMessage,
  },
  async created() {
    const today = new Date();
    this.current_date = this.formatDate(today);
    this.current_day = this.getDayName(today);
    await this.getfeedback();
    await this.getfeedbacksubject();
    await this.getfeedbackcheck();
  },
  methods: {
    getfeedback() {
      axios
        .get(
          `${process.env.VUE_APP_API_COMS}/student/feedback-reason/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.feedbackList = resp.data.data;
            console.log("feedbackList", this.feedbackList);
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    getfeedbacksubject() {
      axios
        .get(
          `${process.env.VUE_APP_API_COMS}/student/feedback-subject-list/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.subjectList = resp.data.data;
            console.log("subjectList", this.subjectList);
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    getfeedbackcheck() {
      axios
        .get(
          `${process.env.VUE_APP_API_COMS}/student/feedback/check/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.feedback_check = resp.data.data;
            if (resp.data.message == "No feedback submitted for today.") {
              this.hidebutton = false;
            } else {
              this.hidebutton = true;
            }
          } else if (resp.data.status == 208) {
            this.feedback_check = resp.data.data;
            if (resp.data.message == "Feedback already submitted for today.") {
              this.hidebutton = true;
            } else {
              this.hidebutton = false;
            }
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    async submitForm() {
      try {
        const feedbackData = this.subjectList.map((subject) => {
          const selectedFeedback = document.querySelector(
            `input[name="feedback-reason-${subject.sub_name}-${subject.session}"]:checked`
          );

          return {
            subject_id: subject.subject_pk.toString(),
            feedback_id: selectedFeedback ? selectedFeedback.value : null,
          };
        });

        const payload = {
          remarks: this.remarks,
          feedbacks: feedbackData,
        };
        console.log("payload", payload);

        axios
          .post(
            `${process.env.VUE_APP_API_COMS}/student/feedback/store/?Key=${localStorage.getItem("LmsId")}`,
            payload
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.getfeedbackcheck();
              this.messages = {
                text: response.data.message,
                type: "success",
              };
              (this.hidebutton = true),
                setTimeout(() => {
                  this.messages = {
                    text: "",
                    type: "null",
                  };
                }, 1500);
            } else if (response.data.status == 208) {
              this.messages = {
                text: response.data.message,
                type: "success",
              };
              (this.hidebutton = true),
                setTimeout(() => {
                  this.messages = {
                    text: "",
                    type: "null",
                  };
                }, 1500);
            } else {
              this.messages = {
                text: response.data.error,
                type: "error",
              };
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "null",
                };
              }, 1500);
            }
          });
      } catch (error) {
        console.error(error);
        alert("An error occurred while submitting feedback.");
      }
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    getDayName(date) {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return days[date.getDay()];
    },
  },
};
</script>

<style></style>
